import { Icon, type IconProps } from './Icon';

export function Check(props: IconProps) {
  return (
    <Icon strokeWidth={2.5} {...props}>
      <path d="M5 12l5 5L20 7" />
    </Icon>
  );
}
